export default __webpack_public_path__ + "static/about-284a1957ad8b28da896fa955af6233b7.gif";